import { SkipPage } from "@/components/pages/skip";

export default function Home() {
  return <SkipPage />;
}
